import { HsRenderFilter } from '../../engine-new/filtering/render-filter.class';
import type { HsGraphicObject } from './graphic-object.class';
import type { HsPerspectiveCamera } from '../../engine-new/objects/cameras/perspective-camera.class';
import type { HsGraphicQueue } from './graphic-queue.class';
import type { HsGraphicLayer } from './graphic-layer.class';

export class HsGraphicFilter extends HsRenderFilter<
  HsGraphicObject,
  HsPerspectiveCamera,
  HsGraphicQueue,
  HsGraphicLayer
> {}
